/*
 * everhound — guarda do brinde no carrinho (rev. 2, 18/10/2026).
 *
 * O brinde ("Free collar & leash set") e uma linha normal com desconto
 * automatico Buy X Get Y. Se o cliente reduzir os potes abaixo do limiar, a
 * Shopify so tira o desconto e a coleira ficaria a $29.97 no carrinho. Aqui:
 *   - a cada cart:update (e no load) le as linhas renderizadas pelo Liquid
 *     (tr[data-eh-gift][data-eh-qty][data-eh-line]);
 *   - soma os potes (linhas que nao sao brinde); se houver brinde e a soma
 *     for menor que data-eh-gift-threshold, remove a linha do brinde pelo
 *     fluxo do proprio tema (cart-items-component.onLineItemRemove) e mostra
 *     "Add {n} more jar(s) to keep your free collar & leash set".
 * Nao toca em product-form.js nem no add-to-cart.
 *
 * T58 (30/10 noite, pedido do Matheus): no maximo UMA coleira-brinde, sempre a $0.00. Com 3 ou
 * mais potes e mais de uma unidade de brinde (3 + 3 pelo buy box, ou outro add que levou a
 * coleira de novo), tira o excesso, uma correcao por cart:update: primeiro a linha cobrada
 * (preco do /cart.js), senao a ultima. O Buy X Get Y volta a cair na que fica. O buy box da
 * -special ja nao manda a segunda (eh-tiers.js); isto cobre o resto.
 */
(function () {
  'use strict';
  if (window.__ehCartGiftGuard) return;
  window.__ehCartGiftGuard = true;

  var notice = { text: '', until: 0 };

  function check() {
    document.querySelectorAll('cart-items-component').forEach(function (c) {
      var rows = c.querySelectorAll('tr[data-eh-gift]');
      var noticeEl = c.querySelector('[data-eh-gift-notice]');
      var threshold = noticeEl ? parseInt(noticeEl.getAttribute('data-eh-gift-threshold'), 10) || 3 : 3;
      var gifts = [];
      var jars = 0;
      rows.forEach(function (r) {
        if (r.getAttribute('data-eh-gift') === 'true') gifts.push(r);
        else jars += parseInt(r.getAttribute('data-eh-qty'), 10) || 0;
      });

      if (jars >= threshold) { notice.text = ''; }

      var giftUnits = 0;
      gifts.forEach(function (r) { giftUnits += parseInt(r.getAttribute('data-eh-qty'), 10) || 0; });
      if (giftUnits > 1 && jars >= threshold && !c.__ehRemovingGift && !dedupeEmCurso) {
        dedupe(c, gifts, giftUnits);
      }

      if (gifts.length && jars < threshold) {
        var missing = threshold - jars;
        notice.text = 'Add ' + missing + ' more jar' + (missing === 1 ? '' : 's') + ' to keep your free collar & leash set';
        notice.until = Date.now() + 15000;
        if (!c.__ehRemovingGift) {
          travar([c]);
          var line = parseInt(gifts[0].getAttribute('data-eh-line'), 10);
          try {
            if (typeof c.onLineItemRemove === 'function' && line > 0) c.onLineItemRemove(line);
          } catch (e) { /* o proximo cart:update tenta de novo */ }
          document.dispatchEvent(new CustomEvent('eh:gift-removed', { detail: { jars: jars, threshold: threshold } }));
        }
      }

      if (noticeEl) {
        var show = !!notice.text && Date.now() < notice.until;
        noticeEl.textContent = show ? notice.text : '';
        noticeEl.hidden = !show;
      }
    });
  }

  /* T58 — tira o excesso de coleiras. O /cart.js diz qual linha esta cobrada (o data-eh-line da
     linha e o indice dela no carrinho). Uma mudanca so: depois dela os indices andam, e o
     proximo cart:update confere de novo. __ehRemovingGift segura a guarda do plano (T38) ate
     a coleira sair, como na remocao abaixo de 3 potes.
     Na pagina /cart ha dois cart-items-component (a gaveta e a pagina) e cada um passaria por
     aqui: a trava e da pagina, e nao do componente, senao as duas coleiras saiam. */
  /* T58 — a trava dura ate o cart:update da propria mudanca (teto de 6 s), e nao 1 s fixo: com
     as conferencias a 700 e 1600 ms, uma resposta lenta deixava a guarda agir sobre a gaveta
     ainda velha, com o indice de linha antigo (e a remocao podia cair na linha errada). */
  var dedupeEmCurso = false;
  function travar(comps) {
    var feito = false;
    comps.forEach(function (x) { x.__ehRemovingGift = true; });
    function solta() {
      if (feito) return;
      feito = true;
      dedupeEmCurso = false;
      comps.forEach(function (x) { x.__ehRemovingGift = false; });
    }
    function aoAtualizar() { document.removeEventListener('cart:update', aoAtualizar); window.setTimeout(solta, 30); }
    document.addEventListener('cart:update', aoAtualizar);
    window.setTimeout(function () { document.removeEventListener('cart:update', aoAtualizar); solta(); }, 6000);
    return solta;
  }
  function dedupe(c, gifts, units) {
    var comps = Array.prototype.slice.call(document.querySelectorAll('cart-items-component'));
    dedupeEmCurso = true;
    var soltar = travar(comps);
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        var linhas = gifts.map(function (r) {
          var line = parseInt(r.getAttribute('data-eh-line'), 10);
          var it = cart && cart.items && cart.items[line - 1];
          var qty = parseInt(r.getAttribute('data-eh-qty'), 10) || 0;
          /* gaveta e /cart.js tem de bater (mesma quantidade na mesma linha); se nao batem, a
             gaveta ainda e a de antes, e a proxima conferencia decide */
          return { line: line, qty: qty, ok: !!it && it.quantity === qty, cobrada: !!(it && it.final_line_price > 0) };
        }).filter(function (l) { return l.line > 0 && l.qty > 0; });
        if (!linhas.length || linhas.some(function (l) { return !l.ok; })) return soltar();
        /* a cobrada primeiro; entre iguais, a de baixo */
        linhas.sort(function (a, b) { return (b.cobrada - a.cobrada) || (b.line - a.line); });
        var alvo = linhas[0];
        var fica = Math.max(0, alvo.qty - (units - 1));
        try {
          if (fica === 0 && typeof c.onLineItemRemove === 'function') c.onLineItemRemove(alvo.line);
          else if (typeof c.updateQuantity === 'function') c.updateQuantity({ line: alvo.line, quantity: fica, action: 'change' });
        } catch (e) { return soltar(); }
        document.dispatchEvent(new CustomEvent('eh:gift-deduped', { detail: { from: units } }));
        /* a trava sai no cart:update desta mudanca */
      })
      .catch(function () { soltar(); });
  }

  /* T58: tambem a 700 e a 1600 ms. Num add pelo buy box o cart:update sai antes de a gaveta ser
     redesenhada; a 60 ms ela ainda mostra o carrinho de antes, e a segunda coleira so seria
     vista no proximo evento. As travas de 1 s seguram a repeticao. */
  document.addEventListener('cart:update', function () {
    [60, 700, 1600].forEach(function (ms) { window.setTimeout(check, ms); });
  });
  document.addEventListener('cart:error', function () { window.setTimeout(check, 60); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check);
  else check();
})();
